import type { McpToken } from 'api';

import { MCP_GRID_TEST_ID } from './constants';
import { McpTokenCard } from './McpTokenCard';

type McpTokenGridProps = {
  tokens: McpToken[];
  onRevoke: (token: McpToken) => void;
};

export const McpTokenGrid = ({ tokens, onRevoke }: McpTokenGridProps) => (
  <div data-testid={MCP_GRID_TEST_ID} className="flex w-full flex-wrap gap-6">
    {tokens.map((token) => (
      <McpTokenCard key={token.uuid} token={token} onRevoke={onRevoke} />
    ))}
  </div>
);
